import '../vendor/toastr/toastr.min.js';

window.toastr.options.closeButton = true;
globalThis.toastr = window.toastr;
